module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.5620/img/provider-signup/community-creators-image.png"